import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const firstCta = document.getElementById('hero-cta');
      if (!firstCta) return;
      setVisible(firstCta.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-36" data-mp="2atgwgawlfs1r">
      {visible && <motion.div initial={{
      y: '110%'
    }} animate={{
      y: 0
    }} exit={{
      y: '110%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-37" data-mp="38b8mg4rheind">
          <div className="mx-auto max-w-xl" data-id="element-38" data-mp="335nejf73wwzd">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-center text-base font-black uppercase tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(30,158,85,0.8)] transition-colors duration-150 ease-out hover:bg-cta-dark sm:text-lg" data-id="element-39" data-mp="2pcxsxbvhpu2s">
              <ShoppingBagIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="26da34pq1bhyo" />
              <span data-id="element-41" data-mp="26fd424sq6vi6">Get Calm Response 5™ · Only $27</span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}